<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZY6VoP/tc-custom/9780226604398.jpg?1722574792640" alt="This image is the cover for the book Maxwell Street"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Maxwell Street
      </h1>
      <p class="bookDescription body article font2">
        <p>What is the nature of place, and how does one undertake to write about it? To answer these questions, geographer and poet Tim Cresswell looks to Chicago’s iconic Maxwell Street Market area. Maxwell Street was for decades a place where people from all corners of the city mingled to buy and sell goods, play and listen to the blues, and encounter new foods and cultures. Now, redeveloped and renamed University Village, it could hardly be more different.<br/>  <br/> In <i>Maxwell Street</i>, Cresswell advocates approaching the study of place as an “assemblage” of things, meanings, and practices. He models this innovative approach through a montage format that exposes the different types of texts—primary, secondary, and photographic sources—that have attempted to capture the essence of the area. Cresswell studies his historical sources just as he explores the different elements of Maxwell Street—exposing them layer by layer. Brilliantly interweaving words and images, <i>Maxwell Street</i> sheds light on a historic Chicago neighborhood and offers a new model for how to write about place that will interest anyone in the fields of geography, urban studies, or cultural history.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tim Cresswell
      </h2>
      
      <p class="authorDescription body article"><B>Tim Cresswell</B> is dean of the faculty, vice president for academic affairs, and professor of America studies at Trinity College in Connecticut. He is the managing editor of the journal <I>GeoHumanities</I>, and the author of many books, including <I>Place: An</I><I>Introduction</I> and <I>Geographic Thought: A Critical Introduction</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a13bb748